import Text from '@/Components/Texts/Text'

export const ProLabel = ({ label }) => {
  return (
    <div className="flex flex-row items-center mb-3">
      <Text className="font-medium mr-1">{label}</Text>
    </div>
  )
}
